import {
  AreaType,
  CreateArea,
  CreateSubArea,
  UpdateArea,
  UpdateSubArea,
} from '@/types/areaZone'
import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const areaApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/area'
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getByParentId(searchParams: SearchParams = {}, parentId: number) {
    const url = `/api/area/parentid/${parentId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getById(interfaceId: Number, id: Number): Promise<{ data: AreaType }> {
    const url = `/api/area/${interfaceId}/${id}`
    return axiosClient.get(url)
  },
  getAreaParent(interfaceId: Number) {
    const url = `/api/area/parent/${interfaceId}`
    return axiosClient.get(url)
  },
  getSubAreaParent(interfaceId: Number, parentId: number) {
    const url = `/api/area/sub/${interfaceId}/${parentId}`
    return axiosClient.get(url)
  },

  create(payload: CreateArea) {
    const url = '/api/area/parent'
    return axiosClient.post(url, payload)
  },
  createSubArea(payload: CreateSubArea) {
    const url = '/api/area'
    return axiosClient.post(url, payload)
  },

  updateArea(payload: UpdateArea) {
    const url = 'api/area/parent'
    return axiosClient.put(url, payload)
  },

  updateSubArea(payload: UpdateSubArea) {
    const url = '/api/area'
    return axiosClient.put(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/area/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
}

export default areaApi
